import React from 'react';
import classNames from 'classnames';

import UpArrowIcon from 'buyside/svgs/up_arrow.svg';
import DownArrowIcon from 'buyside/svgs/down_arrow.svg';

import styles from './directionStyles.scss';

export interface DirectionProps {
  direction: string;
  isSmall?: boolean;
  redacted: boolean;
}

const Direction: React.FunctionComponent<DirectionProps> = ({
  direction,
  isSmall = false,
  redacted
}): React.ReactElement => {
  if (redacted) {
    return (
      <div className={classNames(styles.direction, styles.blur)}>
        <span>{direction}</span>
      </div>
    );
  }

  if (!direction) {
    return <div className={styles.pending}>Pending...</div>;
  }

  return (
    <div
      className={classNames(
        styles.direction,
        { [styles.isLong]: direction === 'long' },
        { [styles.isShort]: direction === 'short' },
        { [styles.isSmall]: isSmall }
      )}
    >
      {(direction === 'short' && <DownArrowIcon className={styles.directionIconDown} />) || (
        <UpArrowIcon className={styles.directionIcon} />
      )}
      <span>{direction && direction.toUpperCase()}</span>
    </div>
  );
};

export default Direction;
